<footer>
    Built with <a href="https://svelte.dev">Svelte <img src="svelte.svg" alt="Svelte Logo"/></a> | Source Code at <a href="https://github.com/sm-sami/Scoreboard">GitHub <img src="github.png" alt="GitHub Logo" /></a>
</footer>

<style>
    footer {
        bottom: 0;
        position: absolute;
        width: 100%;
        padding: 20px 0;
        text-align: center;
        background-color: var(--color-secondary);
    }
    a {
        background-color: var(--color-secondary);
        color: var(--bg-color);
        text-decoration: none;
        font-weight: bold;
    }
    img {
        background-color: var(--color-secondary);
        vertical-align: top;
        width: 15px;
    }
</style>